import { BasketItem } from '../../../schema/basket'
import { InvoiceAddress, PaymentMethod } from '../../../schema/payment'

export const START_PAYMENT: 'cart/START_PAYMENT' = 'cart/START_PAYMENT'
export const REBUILD: 'cart/REBUILD' = 'cart/REBUILD'
export const SET_PACKAGES: 'cart/SET_PACKAGES' = 'cart/SET_PACKAGES'
export const RESET: 'cart/RESET' = 'cart/RESET'
export const PAYMENT_SUCCESS: 'cart/PAYMENT_SUCCESS' = 'cart/PAYMENT_SUCCESS'
export const PAYMENT_FAIL: 'cart/PAYMENT_FAIL' = 'cart/PAYMENT_FAIL'

export type StartPaymentAction = {
  payload: {
    draftId: string,
    cartItems: Array<BasketItem>,
    paymentMethod: PaymentMethod,
    paymentParams?: Object,
    poNumber?: string,
    invoiceAddress?: InvoiceAddress,
  },
  type: typeof START_PAYMENT,
}

export type PaymentSuccessAction = {
  payload: {
    basketId: string,
    context: string,
    paymentMethod: string,
  },
  type: typeof PAYMENT_SUCCESS,
}

export type PaymentFailAction = {
  payload?: string,
  type: typeof PAYMENT_FAIL,
}

export type SetPackagesAction = {
  payload: {
    packages: Array<any>,
  },
  type: typeof SET_PACKAGES,
}

export type RebuildCartAction = {
  payload: {
    paymentAction?: PaymentFailAction | PaymentSuccessAction,
    productCodes: Array<string>,
  },
  type: typeof REBUILD,
}

export type ResetCartAction = {
  type: typeof RESET,
}

export type CartActions =
  | PaymentFailAction
  | PaymentSuccessAction
  | RebuildCartAction
  | ResetCartAction
  | SetPackagesAction
  | StartPaymentAction

export const startPayment = (payload: StartPaymentAction['payload']): StartPaymentAction => ({
  payload,
  type: START_PAYMENT,
})

export const paymentSuccess = (payload: PaymentSuccessAction['payload']): PaymentSuccessAction => ({
  payload,
  type: PAYMENT_SUCCESS,
})

export const paymentFail = (payload?: string): PaymentFailAction => ({
  payload,
  type: PAYMENT_FAIL,
})

export const setPackages = (payload: SetPackagesAction['payload']): SetPackagesAction => ({
  payload,
  type: SET_PACKAGES,
})

export const rebuildCart = (payload: RebuildCartAction['payload']): RebuildCartAction => ({
  payload,
  type: REBUILD,
})

export const resetCart = (): ResetCartAction => ({
  type: RESET,
})
